import PictureNameCard from '../../../components/cards/PictureNameCards/PictureNameCard';
import { getClientName } from '../../../components/special/clientName';

const ProjectClientCard = ({ project }) => {
  return (
    <>
      {project.clientType === 'company' && project.client && (
        <PictureNameCard
          data={project.client}
          pictureUrl={project.client.logo?.thumbnailUrl || ''}
          name={getClientName(project)}
          url={project.client.url}
          phone={project.client.phone}
          mail={project.client.mail}
          type={project.clientType}
        />
      )}
      {project.clientType === 'contact' && project.client && (
        <PictureNameCard
          data={project.client}
          name={getClientName(project)}
          url={project.client.url}
          phone={project.client.phone}
          mail={project.client.mail}
          type={project.clientType}
        />
      )}
    </>
  );
};

export default ProjectClientCard;
